import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseTypography } from '@app/components/common/BaseTypography/BaseTypography';
import styled from 'styled-components';

export const StatusText = styled(BaseTypography.Text)``;

export const Text = styled(BaseTypography.Text)``;

export const FilterCol = styled(BaseCol)`
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
